import React from "react";
import { useNavigate } from "react-router-dom";
import { useStateContext } from "../../../context/contextProvider";
import { useEffect } from "react";

const Companies = () => {
  const {
    baseUrl,
    getAllCompanies,
    dataCompanies,
    dataCompaniesLoading,
    dataCompaniesErrMsg,
    dataCompaniesShowErrMsg,
    getOneCompany
  } = useStateContext();
  useEffect(() => {
    window.scrollTo(0, 0);
    getAllCompanies();
  }, []);

  const navigate  = useNavigate();
  return (
    <div className="tw-mt-[150px] tw-pb-[80px]">
      <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-my-4 tw-p-2">
        <span className="tw-text-second-zain tw-font-bold tw-text-xl md:tw-text-lg sm:tw-text-sm tw-py-3 tw-px-2 tw-pr-4 tw-rounded-sm tw-shadow-sm tw-border-r-2 tw-border-second-zain">
          الشركات والعمال والفنيين
        </span>
      </div>
      <div className="tw-w-[80%] sm:tw-w-[95%] tw-mx-auto tw-p-2">
        <div className="tw-w-full tw-grid tw-grid-cols-3 tw-gap-3 md:tw-grid-cols-2 sm:tw-grid-cols-1 tw-items-center">
          {dataCompaniesLoading ? 
           dataCompanies.length === 0 ?    
           <div className="tw-py-6">
         <div
           className="tw-border-b tw-border-red-500 tw-w-full tw-rounded-lg tw-py-5 tw-px-6 tw-mb-4 tw-text-base tw-text-red-500"
           role="alert"
         >
           عذرا لم تتم الاضافة بعد
         </div>
         </div>
              :
            dataCompanies.map((item, index) => (
              <div
                key={index}
                data-aos="fade-down-left"
                data-aos-duration="900"
                className="tw-flex tw-flex-col tw-justify-center tw-items-center tw-p-4 tw-py-8 tw-border tw-border-gray-50 tw-cursor-pointer tw-rounded-md tw-shadow-sm hover:tw-shadow-lg tw-transition-all tw-duration-500 tw-ease-in-out tw-border-r-2 tw-border-r-second-zain"
                onClick={() => {
                  navigate(`details/${item.company_name}`);
                  sessionStorage.setItem("CompanyId",item.id);
                  getOneCompany(item.id);
                }}
              >
                <div className="tw-w-[100px] tw-h-[100px] sm:tw-w-[40%] tw-mx-auto tw-overflow-hidden tw-rounded-md">
                  <img
                    src={`${baseUrl}${item.image}`}
                    className="tw-w-full tw-h-full tw-object-cover"
                  />
                </div>
                <div>
                  <h3 className="tw-text-gray-500 tw-font-semibold tw-text-xl lg:tw-text-sm md:tw-text-lg xs:tw-text-sm tw-whitespace-nowrap tw-p-4 tw-mt-2">
                    {item.company_name}
                  </h3>
                </div>
              </div>
            ))
           : dataCompaniesShowErrMsg ? 
            <div className=" tw-py-6">
            <div
              className=" tw-border-b tw-border-red-500 tw-w-full tw-rounded-lg tw-py-5 tw-px-6 tw-mb-4 tw-text-base tw-text-red-500"
              role="alert"
            >
              {dataCompaniesErrMsg}
            </div>
            </div>
           : (
            <div
              className="tw-bg-gray-50 tw-rounded-lg tw-py-5 tw-px-6 tw-mb-4 tw-text-base tw-text-gray-500"
              role="alert">
              جاري التحميل...
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default Companies;
